import createMutation from '../utils/createMutation';

export const searchFullDoctor = createMutation(
  '/MedicalDoctor/SearchFullDoctor',
);
export const searchAdvanced = createMutation('/MedicalDoctor/AdvancedSearch');
export const getLookUpConfig = createMutation('/MedicalDoctor/GetLookUpConfig');
export const getSubSpecialty = createMutation(
  '/MedicalDoctor/GetLookupConfigByParents',
);
export const searchClinicArea = createMutation(
  '/MedicalDoctor/SearchClinicArea',
);
export const smartSearch = createMutation('/Search/SmartSearch');
